var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "800"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "code-of-conduct-dialog"
  }, [_c('v-app-bar', {
    attrs: {
      "flat": "",
      "height": "56",
      "color": "#fff"
    }
  }, [_c('v-toolbar-title', [_vm._v("위드캔복지재단 행동강령")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "#111",
      "text": "",
      "icon": "",
      "aria-label": "닫기"
    },
    on: {
      "click": function ($event) {
        _vm.dialog = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-divider'), _c('v-card-title', [_c('div', {
    staticClass: "code-of-conduct-dialog__title"
  }, [_vm._v("위드캔복지재단 행동강령")])]), _c('v-card-text', _vm._l(_vm.items, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "py-24"
    }, [_c('v-row', {
      staticClass: "row--sm"
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "tit tit--sm grey-1--text"
    }, [_vm._v(" " + _vm._s(item.name) + " ")])]), _c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('p', {
      staticClass: "page-text"
    }, [_vm._v(" " + _vm._s(item.text) + " ")])])], 1)], 1);
  }), 0)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }